import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';
class DVCFileM01API extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFileM01s';
}
export default new DVCFileM01API();
